import React from 'react';
import { Folder, BarChart3, LayoutGrid, Scale, HardDrive } from 'lucide-react';
import styles from './LandingEcosystem.module.scss';

interface ServiceItem {
  title: string;
  description: string;
  icon: React.ComponentType<{ size?: number; className?: string }>;
  accent?: boolean;
  wide?: boolean;
  full?: boolean;
}

const services: ServiceItem[] = [
  {
    title: 'Accounting',
    description:
      'Manage company workflows across transactions and POS — all from one unified hub.',
    icon: Folder,
    wide: true,
  },
  {
    title: 'Reports',
    description:
      'Generate business reports to track performance, income, and balance in real time.',
    icon: BarChart3,
    accent: true,
  },
  {
    title: 'Kanban & Collaboration',
    description:
      'Coordinate work with visual Kanban boards so teams stay aligned.',
    icon: LayoutGrid,
  },
  {
    title: 'Memberships',
    description:
      'Manage invitations, history, settings, and content directly in Abrasoft Hub.',
    icon: Scale,
    accent: true,
    wide: true,
  },
  {
    title: 'Storage & Files',
    description:
      'Keep assets and documents organized with secure, accessible storage.',
    icon: HardDrive,
    full: true,
  },
];

function LandingEcosystem() {
  return (
    <section
      className={styles.section}
      id="hub-services"
      aria-label="Hub services"
    >
      <div className={styles.inner}>
        <div className={styles.bentoVisual} aria-hidden="true">
          <img
            src={`${import.meta.env.BASE_URL}landing-bento.jpg`}
            alt=""
            className={styles.bentoImage}
            loading="lazy"
          />
          <div className={styles.bentoImageOverlay} />
        </div>
      </div>

      <div className={styles.cardsSection}>
        <div className={styles.cardsSectionInner}>
          <div className={styles.grid} role="list">
            {services.map((service) => {
              const Icon = service.icon;
              return (
                <article
                  key={service.title}
                  className={`${styles.card} ${service.wide ? styles.cardWide : ''} ${service.full ? styles.cardFull : ''} ${service.accent ? styles.cardAccent : ''}`}
                  role="listitem"
                >
                  <div className={styles.cardIcon} aria-hidden="true">
                    <Icon size={24} />
                  </div>
                  <h3 className={styles.cardTitle}>{service.title}</h3>
                  <p className={styles.cardDescription}>
                    {service.description}
                  </p>
                  <div className={styles.cardGlow} aria-hidden="true" />
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default LandingEcosystem;
